import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React, { useState } from "react";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
import classNames from "classnames";
import { getInputBorderAndBackgroundClasses } from "../../../utils/fieldValidation";
var TagInput = function TagInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    formatHint = _ref.formatHint,
    pattern = _ref.pattern,
    maxLength = _ref.maxLength,
    disabled = _ref.disabled,
    isEmpty = _ref.isEmpty,
    isRequired = _ref.isRequired,
    errorMessage = _ref.errorMessage,
    isShouldBeBlankError = _ref.isShouldBeBlankError;
  var _useState = useState(""),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];

  // Normalize value to array
  var tags = Array.isArray(value) ? value : value ? [value] : [];
  var shouldShowServerError = !isEmpty && !!errorMessage;
  var shouldShowError = !!error || shouldShowServerError;
  var borderAndBackgroundClasses = getInputBorderAndBackgroundClasses(shouldShowError, isRequired !== null && isRequired !== void 0 ? isRequired : false, isEmpty !== null && isEmpty !== void 0 ? isEmpty : false);
  var addTag = function addTag() {
    var trimmed = inputValue.trim();
    if (!trimmed) return;
    if (pattern) {
      var regex = new RegExp(pattern);
      if (!regex.test(trimmed)) {
        setError(formatHint || "Invalid format");
        return;
      }
    }
    if (tags.includes(trimmed)) {
      setError("Already added");
      return;
    }
    setError(null);
    onChange([].concat(_toConsumableArray(tags), [trimmed]));
    setInputValue("");
  };
  var removeTag = function removeTag(index) {
    onChange(tags.filter(function (_, i) {
      return i !== index;
    }));
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    } else if (e.key === "Backspace" && !inputValue && tags.length > 0) {
      removeTag(tags.length - 1);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-wrap gap-1.5 w-full px-4 py-3 border rounded-lg items-center focus-within:border-teal-500 focus-within:ring-1 focus-within:ring-teal-500 dark:focus-within:border-teal-400", borderAndBackgroundClasses, {
      "opacity-60 cursor-not-allowed": disabled
    })
  }, tags.map(function (tag, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      className: "inline-flex items-center gap-1 px-2 py-0.5 text-sm bg-teal-100 dark:bg-teal-600/20 text-teal-700 dark:text-teal-400 border border-teal-300 dark:border-teal-500/30 rounded"
    }, tag, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return removeTag(index);
      },
      className: "hover:text-teal-900 dark:hover:text-teal-200",
      type: "button"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faXmark,
      className: "h-2.5 w-2.5"
    })));
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: inputValue,
    disabled: disabled,
    maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : undefined,
    onChange: function onChange(e) {
      setInputValue(e.target.value);
      setError(null);
    },
    onKeyDown: handleKeyDown,
    onBlur: addTag,
    placeholder: tags.length === 0 ? placeholder : "Add...",
    style: {
      border: "none",
      outline: "none",
      boxShadow: "none"
    },
    className: "flex-1 min-w-[60px] bg-transparent text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 p-0"
  })), (error || shouldShowServerError) && /*#__PURE__*/React.createElement("div", {
    className: "text-red-600 dark:text-red-400 text-xs mt-1"
  }, error || errorMessage), !error && !shouldShowServerError && formatHint && /*#__PURE__*/React.createElement("div", {
    className: "text-gray-600 dark:text-gray-500 text-xs mt-1"
  }, formatHint));
};
export default TagInput;